import Reveal from "@/components/Reveal";

const SectionHeading = ({ title, subtitle }) => (
    <Reveal className="mx-auto mb-14 max-w-3xl text-center sm:mb-20">
        <h2 className="font-display text-3xl font-bold tracking-tight text-slate-50 sm:text-4xl lg:text-5xl">
            {title}
        </h2>
        {subtitle && (
            <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-slate-400 sm:text-lg">
                {subtitle}
            </p>
        )}
    </Reveal>
);

export default SectionHeading;
